import { render, staticRenderFns } from "./mine_side.vue?vue&type=template&id=4683c152&scoped=true"
import script from "./mine_side.vue?vue&type=script&lang=js"
export * from "./mine_side.vue?vue&type=script&lang=js"
import style0 from "./mine_side.vue?vue&type=style&index=0&id=4683c152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683c152",
  null
  
)

export default component.exports